import get from 'lodash.get';
import { PropTypes } from 'prop-types';
import React from 'react';
import { createUseStyles } from 'react-jss';

import Features from '../../../features.json';
import DeleteAccoutButton from './delete-account-button';
import ExportButton from './export-button';
import ImportButton from './import-button';
import LastActivity from './last-activity';
import LogoutButton from './logout-button';
import ProfilePicture from './profile-picture';
import UserInfos from './user-infos';

const useStyles = createUseStyles({
  exports: {
    composes: ['flex-rows', 'flex-center', 'p12'],
    height: '100%',
  },
  userProfile: {
    composes: ['flex-rows', 'flex-start', 'px15', 'is-relative'],
  },
});

const ProfileViewComponent = React.memo(({ user }) => {
  const classes = useStyles();

  const email = get(user, 'email', null);
  const name = get(user, 'displayName', null);
  const photoURL = get(user, 'photoURL', null);
  const providerId = get(user, 'providerData.0.providerId', null);
  return (
    <div className={classes.userProfile}>
      <ProfilePicture photoURL={photoURL} providerId={providerId} />
      <UserInfos email={email} name={name} />
      <LastActivity />
      <div className={classes.exports}>
        <ImportButton />
        <ExportButton />
      </div>
      <LogoutButton />
      {Features.delete_account && <DeleteAccoutButton />}
    </div>
  );
});

ProfileViewComponent.propTypes = {
  user: PropTypes.shape().isRequired,
};

ProfileViewComponent.displayName = 'ProfileViewComponent';

export default ProfileViewComponent;
